<div class="trinka_cloud_wrap" #target>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="trinka_cloud_banner_text">
                        <h1>Trinka 學術寫作語句庫</h1>
                        <p>幫你挑出最合適的寫作句型，清楚傳達、避免重複用語
                        </p>

                        <div class="contact" id="phasebankEmailBox">
                            <form class="form-inline" [formGroup]="phaseBankSearchForm" (ngSubmit)="phaseBankSearch()">
                                <div class="form-group ">

                                    <input placeholder="&#xF002; 輸入語句找相似用法" formControlName="sentence" class="form-control" name="email">
                                </div>
                                <button type="submit" id="phasebank" class="btn btn-primary">Find Phrases</button>
                            </form>
                        </div>
                        <p class="phasebanknote">例如： "This represents an important topic to study because"</p>
                        <div class="purplephasebank">
                            <a [routerLink]="['/academic-phrasebank-browse', 'topic', 'subtopic']">或瀏覽我們分章節整理的語句範例</a>
                        </div>
                        <div class="disclaimercontents">
                            <p>本頁提供的資訊可自由用於學術用途。如需商業使用，<a href="mailto:sales&#64;trinka&#46;ai">請與我們聯繫</a>。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="section-pd-sm section-purple list-wrapper-style-2">
        <div class="trinka_container">
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-none">
                        <img src="../../../assets/images/brain.png" alt="brain" srcset="">
                        <h3>用 AI 快速找到最合適的語句</h3>
                        <p>
                            我們專門訓練的 AI 模型，能在短短幾秒內，從龐大的學術語句庫中幫你快速找到合適的句型，讓你寫作更有自信，節省寶貴時間。
                        </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards">
                        <img src="../../../assets/images/network.png" alt="brain" srcset="">
                        <h3>龐大學術資料庫</h3>
                            <p>我們的學術語句庫蒐集自數百萬篇學術出版品中的常用片語，幫助你輕鬆表達寫作意圖，同時符合學術慣例。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards pr-25">
                        <img src="../../../assets/images/snap.png" alt="brain" srcset="">
                        <h3>搜尋簡單，使用便利</h3>
                            <p>節省時間，自信寫作！我們結合 AI 技術的學術語句庫，讓你快速輕鬆找到合適的表達句型。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="most_suited_for_section">
        <div class="container">
            <div class="row">
                <div class="col-md-4">
                    <div class="features_cards">
                        <img src="../../../assets/images/brain.png" alt="brain" srcset="">
                        <div class="features_cards_inner">
                            <h3>AI to Find the Right Phrase</h3>
                            <p>
                                Our specially trained AI model saves you time finding the right phrase to write confidently from our large
                                <b>academic phrasebank</b>
                                in just seconds.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="features_cards">
                        <img src="../../../assets/images/network.png" alt="brain" srcset="">
                        <div class="features_cards_inner">
                            <h3>Large Academic Database</h3>
                            <p>
                                Our
                                <b>academic phrasebank</b> curates phrases from millions of academic publications to help you
                                easily express your intent while meeting academic conventions. </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="features_cards">
                        <img src="../../../assets/images/snap.png" alt="brain" srcset="">
                        <div class="features_cards_inner">
                            <h3>Easy to Search and Use</h3>
                            <p>Save time and write confidently using our
                                <b>academic phrasebank</b> powered by AI technology that makes finding the right phrases quick
                                and easy.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->


</div>

<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container">
        <div class="row align-items-center flex-row-reverse">
            <div class="col-md-6">
                <div class="list-wrapper-content-2">
                    <h3>關於 Trinka 的學術語句庫</h3>
                    <p>Trinka 的學術語句庫是一個龐大的英文片語與句型資料庫，幫助你快速找到符合學術寫作慣例與風格的合適表達，精準傳達你的寫作意圖。</p>
                    <p>Trinka 的學術語句庫收錄了科學期刊論文及其他學術出版品中常用的片語與句子。這些資料由專業學者與資深編輯團隊精心策劃整理，品質有保障。</p>
                    <p>我們獨特的 AI 技術，提供高度相關的搜尋結果，幫助你節省撰寫學術內容的寶貴時間。
                    </p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image">
                    <img src="../../../assets/images/enterprise/safe-secure.webp" alt="safe" class="img-fluid">
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2 pt-0">
    <div class="trinka_container">
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="list-wrapper-content-2 pr-80">
                    <h3>Trinka 的學術語句庫如何運作？</h3>

                        <p>使用 Trinka 的學術語句庫，你可以透過兩種簡單方式，輕鬆找到合適的片語或句子，有效傳達你的訊息。</p>
                        <p class="purple_bullet">
                            搜尋與你已有片語相似的語句，輸入或貼上你的片語，Trinka 的 AI 將理解片語的意涵，並顯示所有相關的相似句型。
                            只要點擊你喜歡的建議，便能輕鬆複製使用 
                        </p>
                        <p class="purple_bullet">
                            透過分類導航使用學術語句庫，假如你想在引言部分介紹先前的研究，並說明主題的重要性，只要點選分類中的「介紹你的研究」，接著選擇子分類「說明主題的重要性」，就能看到所有相關的語句建議，輕鬆點擊即可複製使用！
                        </p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image">
                    <a href="" data-toggle="modal" data-target="#youtubeModalPopup" id="VewiVideoSection">
                        <img src="assets/images/yt-thumbnail/academicPhraseBank.webp" width="1281" height="718" alt="academic phrase bank" class="img-fluid eposter-img" />
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="softWare_workFlow cloud_key_features section-pd pt-0">
    <div class="trinka_container">
        <div class="row">
            <!-- <div class="col-md-12">

            </div> -->
            <div class="col-md-6">
                <div class="trinka-title">
                    <h2>Trinka 的學術語句庫 vs. 曼徹斯特學術語句庫</h2>
                    <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                    <p>曼徹斯特學術語句庫由曼徹斯特大學的約翰‧莫利博士（Dr. John Morley）整理編撰。你可以下載 PDF 檔案或直接在他們的網站上使用該語句庫。</p>
                    <p>Trinka 的學術語句庫是一個完整可搜尋且方便瀏覽的學術片語庫，專為作者打造。它的資料庫規模遠大於曼徹斯特學術語句庫，收錄了數百萬篇已發表文章中的片語，堪稱非常全面的學術語句資源。</p>
                    <p>此外，Trinka 的學術語句庫結合 AI 技術，讓你透過簡單搜尋輕鬆找到相關片語。分類清楚的語句庫也方便你瀏覽，快速找到最適合的表達句型。
                    </p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="phasebankFeatures">
                    <ul>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/curated-researcher.png" alt="curated-researcher" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3 class="text-white">規模龐大且嚴謹的學術資料庫</h3>
                                    <p>Trinka 的學術語句庫使用龐大的學術資料庫，涵蓋來自各學科多家知名期刊的數百萬篇已發表論文內容。
                                    </p>
                                </div>
                            </div>
                        </li>
                        <!-- <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/Highly-secured.png" alt="" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Highly Secure</h3>
                                    <p>We adheres to the strictest global standards to ensure maximum security for our clients.
                                        AI does not learn from your anonymized data, your data is yours alone.</p>
                                </div>
                            </div>
                        </li> -->
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/ai.png" alt="ai powered" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3 class="text-white">AI 智慧搜尋</h3>
                                    <p>Trinka 的學術語句庫結合 AI 技術，讓你只需簡單搜尋，就能快速找到合適的片語，幫助你節省寫作時間。

                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/Ease-to-use.png" alt="easy to navigate" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3 class="text-white">操作簡便</h3>
                                    <p>Trinka 的學術語句庫依照論文各部分內容分類，讓你輕鬆找到適合的語句，準確傳達每個段落的意涵。
                                    </p>
                                </div>
                            </div>
                        </li>

                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="section-pd section-purple">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title text-center">
                    <h2>全球研究人員信賴的選擇</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>Trinka AI 深受全球研究人員青睞，是他們寫作與發表的首選工具。除了提供豐富的學術片語庫，全球的技術寫手與學者更倚賴 Trinka 精準的文法修正與語言潤飾功能。與大多數工具不同，Trinka 不僅著重文法，更從整體語言品質著手，幫助提升出版成功率。</p>
                    <div class="btn-group justify-content-center mt-4">
                        <a href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank" rel="noopener noreferrer" class="filled-btn">立即試用</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="faqQuestionAnwser section-pd " #target>
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>學術語句庫常見問答</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        為什麼要使用學術語句庫？</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>撰寫學術論文是一項挑戰，不僅需要文法正確，還要遵守多項寫作規範，同時確保表達有力且具說服力。Trinka 的學術語句庫能幫助你更快速準備論文，讓你直接使用標準學術出版品中的常用片語，無需費時搜尋和閱讀大量文獻來尋找合適的表達。使用 Trinka 的學術語句庫，能節省時間，也讓你更有信心完成論文撰寫。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">使用 Trinka 的學術語句庫需要付費嗎？</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka 的學術片語庫專為學術作者和學生打造，幫助您有效寫作。這項服務完全免費，且無使用限制。
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        使用學術語句庫的片語會被視為抄襲嗎？
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka 的學術語句庫提供的片語，目的是幫助你達成特定的溝通目的。當你使用這些片語時，需要進一步擴展內容，完整傳達你的想法，讓最終的作品成為你獨一無二的版本。因此使用 Trinka 的學術語句庫片語並不會構成抄襲。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        Trinka 的學術語句庫適用哪些學科？
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka 的學術片語庫涵蓋來自數百萬篇涵蓋所有科學領域的標準片語，因此適用於任何學科。
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal" id="youtubeModalPopup">
    <div class="modal-dialog modal-dialog-centered modal-lg">
       <div class="modal-content">
          <div class="modal-body no-padding">
             <button type="button" class="btn-close" data-dismiss="modal" (click)="stopAllVideos()"></button>
             <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/ingGxMsQgdI"
                title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
          </div>
       </div>
    </div>
</div>